import { useGetFeatureFlagsQueryOptions } from "@/api/config/config"
import { MyAccountRoute } from "@/constants/routes/myAccount"
import ErrorReporter from "@/services/ErrorReporter"
import { useQueryClient } from "@tanstack/vue-query"
import { NavigationGuard } from "vue-router"

// Redirects bookmarks of the legacy /prize-draw and /rewards URLs to the new
// /offers-and-rewards page when the So Rewarding v2 flag is on. If the flag
// is off (or the lookup fails) we fall through and let the legacy view render.
export const soRewardingRedirectGuard: NavigationGuard = async () => {
  try {
    const queryClient = useQueryClient()
    const flags = await queryClient.ensureQueryData(
      useGetFeatureFlagsQueryOptions(),
    )
    if (flags.soRewardingV2) {
      return { path: MyAccountRoute.rewards }
    }
  } catch (error) {
    ErrorReporter.report(error)
  }
}
